import { makeDataErrorMessages } from '@atlassian/amkt-common';
import { getScopesLookup } from '@atlassian/mpac-api-client';
export const FETCH_SCOPES_LOOKUP = 'SCOPES_FETCH_SCOPES_LOOKUP';
export const RECEIVE_SCOPES_LOOKUP = 'SCOPES_RECEIVE_SCOPES_LOOKUP';
export const RECEIVE_SCOPES_LOOKUP_ERROR = 'SCOPES_RECEIVE_SCOPES_LOOKUP_ERROR';
const fetchScopesLookup = () => ({
  type: FETCH_SCOPES_LOOKUP
});
const receiveScopesLookup = _ref => {
  let {
    scopesLookup
  } = _ref;
  return {
    type: RECEIVE_SCOPES_LOOKUP,
    scopesLookup
  };
};
const receiveScopesLookupError = _ref2 => {
  let {
    dataErrorMessages
  } = _ref2;
  return {
    type: RECEIVE_SCOPES_LOOKUP_ERROR,
    dataErrorMessages
  };
};
export const doRetrieveScopesLookup = _ref3 => {
  let {
    bootstrapConfig
  } = _ref3;
  return dispatch => {
    dispatch(fetchScopesLookup());
    getScopesLookup(bootstrapConfig.graphQLGatewayUrl).then(scopesLookup => {
      dispatch(receiveScopesLookup({
        scopesLookup
      }));
    }, error => {
      dispatch(receiveScopesLookupError({
        dataErrorMessages: makeDataErrorMessages('status' in error ? [error.status.toString()] : [error.message])
      }));
    });
  };
};